import { GetIndustries } from "@/server-types";
import { useCustomQuery } from "../custom-query";
import { get } from "../request-helpers";

/**
 * GET /industry
 */
export const useGetIndustries = (enabled: boolean = true) => {
  return useCustomQuery({
    queryKey: ["industries", "dashboard"],
    queryFn: () => get<GetIndustries>("/industry"),
    enabled,
  });
};
